<template>
  <header class="settings-head">
    <div class="settings-head-text">
      <h1>{{ title }}</h1>
      <p v-if="subtitle" class="settings-subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.actions" class="settings-head-actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  subtitle?: string;
}>();
</script>
